import React from 'react';
import { COLORS, META } from '../../globalStyles';
import { styles as doc } from '../../components/documentPage/styles';

export const styles: Record<string, React.CSSProperties> = {

  // Same chrome and typography as /legal — the 404 is a document page, not a broken one.
  pageTitle: doc.title,
  paragraph: doc.paragraph,

  // The status code as the site's index motif: the zero-padded numeric labels used for
  // services, products and the legal rows.
  code: {
    ...META,
    fontSize: '0.72rem',
    color: COLORS.accent,
    marginBottom: '0.9rem',
  },
  home: {
    ...META,
    display: 'inline-block',
    marginTop: '1.5rem',
    fontSize: '0.66rem',
    color: COLORS.accent,
    textDecoration: 'none',
    borderBottom: `1px solid ${COLORS.borderAccent}`,
    paddingBottom: '0.25rem',
  },
};
